<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">
  <section class="pricing text-center bg-light">
    <div class="pagetitle text-center">
      <h1>Pricing</h1>
      <div class="div-page-description"><h5>Unlock the full potential of our cutting-edge tool with our tailored pricing options.</h5></div>
    </div>
    <div class="container">

      <section class="section" id="pricing">
        <div class="row pt-4">

          <div class="col-lg-4">
            <div class="pricing-box mt-4" [ngClass]="{'activePrice': currentPlan=='basic'}">
              <div class="pricing-badge" *ngIf="currentPlan=='basic'">
                <span class="badge" style="background-color: mediumseagreen">Active</span>
              </div>
              <!--<i class="mdi bi-people-fill h1"></i>-->
              <h3 class="fw-bold">Basic</h3>

              <div class="mt-4 pt-2">
                <p class="mb-2 f-18">Features</p>

                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  <b> 3</b> Domains
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Index<b> 200</b> URLs Daily
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Indexing History
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Auto Indexing
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  SEO Tools
                </p>
              </div>

              <p class="mt-4 pt-2 text-muted">
                Ideal for individuals with a limited number of pages to be indexed
              </p>

              <div class="pricing-plan mt-4 pt-2">
                <h4 class="text-muted"><s> $13</s> <span class="plan pl-3 text-dark"> $10 </span></h4>
                <p class="text-muted mb-0">Per Month</p>
              </div>

              <div class="mt-4 pt-3">
                <button *ngIf="userToken==null || currentPlan=='starter'" (click)="getPaymentLinks('basic')" class="btn btn-primary btn-rounded">Purchase Now</button>
                <button *ngIf="userToken!=null && currentPlan!='basic' && currentPlan!='starter'" class="btn btn-primary btn-rounded" (click)="manageSubscription()">Switch Plan</button>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="pricing-box mt-4" [ngClass]="{'activePrice': currentPlan=='pro'}">
              <div class="pricing-badge" *ngIf="currentPlan!='pro'">
                <span class="badge">Featured</span>
              </div>
              <div class="pricing-badge" *ngIf="currentPlan=='pro'">
                <span class="badge" style="background-color: mediumseagreen">Active</span>
              </div>
              <!--<i class="mdi bi-person-fill h1"></i>-->
              <h3 class="f-20 fw-bold">Pro</h3>

              <div class="mt-4 pt-2">
                <p class="mb-2 f-18">Features</p>

                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  <b> 10</b> Domains
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Index<b> 400</b> URLs Daily
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Indexing History
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Auto Indexing
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  SEO Tools
                </p>
              </div>

              <p class="mt-4 pt-2 text-muted">
                Ideal for individuals regularly publishing a high volume of pages
              </p>
              <div class="pricing-plan mt-4 pt-2">
                <h4 class="text-muted"><s> $25</s> <span class="plan pl-3 text-dark"> $22 </span></h4>
                <p class="text-muted mb-0">Per Month</p>
              </div>

              <div class="mt-4 pt-3">
                <button *ngIf="userToken==null || currentPlan=='starter'" (click)="getPaymentLinks('pro')" class="btn btn-primary btn-rounded">Purchase Now</button>
                <button *ngIf="userToken!=null && currentPlan!='pro' && currentPlan!='starter'" class="btn btn-primary btn-rounded" (click)="manageSubscription()">Switch Plan</button>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="pricing-box mt-4" [ngClass]="{'activePrice': currentPlan=='enterprise'}">
              <div class="pricing-badge" *ngIf="currentPlan=='enterprise'">
                <span class="badge" style="background-color: mediumseagreen">Active</span>
              </div>
              <!--<i class="mdi bi-person-fill h1"></i>-->
              <h3 class="f-20 fw-bold">Enterprise</h3>

              <div class="mt-4 pt-2">
                <p class="mb-2 f-18">Features</p>

                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  <b> 50</b> Domains
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Index<b> 600</b> URLs Daily
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Indexing History
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Auto Indexing
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  SEO Tools
                </p>
              </div>

              <p class="mt-4 pt-2 text-muted">
                Ideal for agencies regularly publishing a high volume of pages
              </p>
              <div class="pricing-plan mt-4 pt-2">
                <h4 class="text-muted"><s> $42</s> <span class="plan pl-3 text-dark"> $39 </span></h4>
                <p class="text-muted mb-0">Per Month</p>
              </div>

              <div class="mt-4 pt-3">
                <button *ngIf="userToken==null || currentPlan=='starter'" (click)="getPaymentLinks('enterprise')" class="btn btn-primary btn-rounded">Purchase Now</button>
                <button *ngIf="userToken!=null && currentPlan!='enterprise' && currentPlan!='starter'" class="btn btn-primary btn-rounded" (click)="manageSubscription()">Switch Plan</button>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="pricing-box mt-4" [ngClass]="{'activePrice': currentPlan=='advanced'}">
              <div class="pricing-badge" *ngIf="currentPlan=='advanced'">
                <span class="badge" style="background-color: mediumseagreen">Active</span>
              </div>
              <!--<i class="mdi bi-person-fill h1"></i>-->
              <h3 class="f-20 fw-bold">Advanced</h3>

              <div class="mt-4 pt-2">
                <p class="mb-2 f-18">Features</p>

                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  <b> 60</b> Domains
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Index<b> 1000</b> URLs Daily
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Indexing History
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Auto Indexing
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  SEO Tools
                </p>
              </div>

              <p class="mt-4 pt-2 text-muted">

                Ideal for independent SEO professionals and corporate entities.
              </p>
              <div class="pricing-plan mt-4 pt-2">
                <h3 class="text-muted"> <span class="pl-3 text-dark"> Available Soon </span></h3>
                
              </div>

            
            </div>
          </div>

          <div class="col-lg-4">
            <div class="pricing-box mt-4" [ngClass]="{'activePrice': currentPlan=='scale'}">
              <div class="pricing-badge" *ngIf="currentPlan=='scale'">
                <span class="badge" style="background-color: mediumseagreen">Active</span>
              </div>
              <!--<i class="mdi bi-person-fill h1"></i>-->
              <h3 class="f-20 fw-bold">Scale</h3>

              <div class="mt-4 pt-2">
                <p class="mb-2 f-18">Features</p>

                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  <b> 70</b> Domains
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Index<b> 1600</b> URLs Daily
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Indexing History
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  Auto Indexing
                </p>
                <p class="mb-2">
                  <i class="icon bi-check-circle-fill text-success f-18 mr-2"></i>
                  SEO Tools
                </p>
              </div>

              <p class="mt-4 pt-2 text-muted">
                Tailored for corporate entities and SEO agencies.
              </p>
              <div class="pricing-plan mt-4 pt-2">
                <h3 class="text-muted"> <span class="pl-3 text-dark"> Available Soon </span></h3>

              </div>

             
            </div>
          </div>

          <div class="col-lg-4">
            <div class="pricing-box mt-4">

              <!--<i class="mdi bi-person-fill h1"></i>-->
              <h3 class="f-20 fw-bold">Need More?</h3>

         

              <p class="mt-4 pt-2 text-muted">
                Please contact us for larger plans.
              </p>
          
            </div>
          </div>

          
        </div>
      </section>
    </div>
  </section>
</main>

<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
